export const retweet = () => (
  <path
    d="M1 9l4-4m0 0l4 4M5 5v11a3 3 0 003 3h5m10-4l-4 4m0 0l-4-4m4 4V8a3 3 0 00-3-3h-5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
